import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

const chartSetting = {
  xAxis: [
    {
      label: "Spending(£)",
    },
  ],
  height: 400,
};

const valueFormatter = (value) => `${value}(£)`;

function HorizontalBars({ attractions, transport, food, shopping, other }) {
  if (
    [attractions, transport, food, shopping, other].every(
      (value) => value === 0
    )
  ) {
    return (
      <p>No expenses added yet. Chart will appear once data is available.</p>
    );
  }

  const categories = [
    { totalSpend: attractions, category: "Attractions & Trips" },
    { totalSpend: transport, category: "Transport" },
    { totalSpend: food, category: "Food & Drink" },
    { totalSpend: shopping, category: "Shopping" },
    { totalSpend: other, category: "Other" },
  ];

  return (
    <BarChart
      dataset={categories}
      yAxis={[{ scaleType: "band", dataKey: "category" }]}
      series={[{ dataKey: "totalSpend", valueFormatter }]}
      layout="horizontal"
      {...chartSetting}
    />
  );
}

export default HorizontalBars;
